import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api-stack-api.onrender.com',
  // No need to include authorization headers here
});

export default api;
